import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { MeetingsService } from '@app/services/meetings/meetings.service';

import { Subscription } from 'rxjs';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { ActivatedRoute } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { Sort } from '@angular/material/sort';

interface SearchMeetingResult {
  id: number;
  meetingDate: string;
  issue: string;
  comment: string;
  meetingTypeName: string;
  numberOfAttendances: number;
  numberofguestattendances: number;
  numberofowninstitutionattendances: number;
}

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

@Component({
  selector: 'app-searchmeeting',
  templateUrl: './searchmeeting.component.html',
  styleUrls: ['./searchmeeting.component.css']
})
export class SearchmeetingComponent implements OnInit, OnDestroy {
  @Input() institution;
  @Input() type;
  @Output() closeSearchMeeting: EventEmitter<any> = new EventEmitter();
  addmeetingview = false;
  institutiondata: LodgeAndCamp;
  permissions;
  institutionaccess;
  resultlist: SearchMeetingResult[] = [];
  subscriptions: Subscription[] = [];
  items: SelectItem[];
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  searchmeetingform;
  
  test;

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private meetingService: MeetingsService,
    private permissionsService: PermissionsService) { }

  ngOnInit() {
    this.searchmeetingform = this.fb.group({
      institutionId: [null, null],
      FromDate: ['', ''],
      ToDate: ['', ''],
      issue: ['', ''],
      comment: ['', ''],
      meetingTypeId: ['', '']
    });
    
    this.activatedRoute.queryParams.subscribe(qParams => {
      this.searchmeetingform.patchValue({ institutionId: +qParams.id });
      this.institution.id = +qParams.id;
      this.search();
    });

    this.permissionsService.access.subscribe(x => {
      this.permissions = x.role?.permissions;
    });

    this.permissionsService.institutionaccess.subscribe(a => {
      if (a) {
        this.institutionaccess = a;
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  search() {
    this.searchmeetingform.get('institutionId').setValue(this.institution.id);
    this.subscriptions.push(this.meetingService.searchMeeting(this.searchmeetingform.value).subscribe(data => {
      this.resultlist = data;
    }));
  }

  sortData(sort: Sort) {
    const data = this.resultlist.slice();
    if (!sort.active || sort.direction === '') {
      this.resultlist = data;
      return;
    }

    this.resultlist = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        // case 'no': return this.compare(a.id, b.id, isAsc);
        case 'meetingDate': return this.compare(a.meetingDate, b.meetingDate, isAsc);
        case 'issue': return this.compare(a.issue, b.issue, isAsc);
        case 'comment': return this.compare(a.comment, b.comment, isAsc);
        case 'meetingTypeName': return this.compare(a.meetingTypeName, b.meetingTypeName, isAsc);
        case 'numberOfAttendances': return this.compare(a.numberOfAttendances, b.numberOfAttendances, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  close() {
    this.closeSearchMeeting.emit();
  }

  addMeeting() {
    this.addmeetingview = true;
  }

  closeAddMeeting(evt) {
    this.addmeetingview = false;
  }
}
